/// <reference path="../app.module.ts" />
import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../shared/services/repository.service';
import { Risk } from './../_interfaces/risk.model';
import { RiskUser } from './../_interfaces/RiskUser.model';
import { RiskEvent } from "./../_interfaces/RiskEvent.model";
import { MitigatingAction } from "./../_interfaces/MitigatingAction.model";
import { Router } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RiskService } from '../shared/services/risk.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public riskType: number;

  riskData$: Observable<Risk[]>;
  overdueRisks$: Observable<Risk[]>;
  alertRisks$: Observable<Risk[]>;
  riskEvents$: Observable<RiskEvent[]>;
  approvalRiskEvents$: Observable<RiskEvent[]>;
  mitigatingActions$: Observable<MitigatingAction[]>;
  overdueMitigatingActions$: Observable<MitigatingAction[]>;

  public userIsSetup: boolean;
  public showApprovals: boolean;

  public showRisks: boolean;
  public showAlertRisks: boolean;
  public showMitigations: boolean;
  public showRiskEvents: boolean;

  public user: RiskUser;

  constructor(
    private repository: RepositoryService,
    private router: Router,
    private riskService: RiskService
  ) {

    this.userIsSetup = false;
  } // end of constructor

  ngOnInit() {
    this.repository.GetMyUserRemote()
          .subscribe(res => {
            this.repository.user = res as RiskUser;
            this.user = this.repository.user
            this.userIsSetup = true;
            this.repository.userIsSetup = true;
            this.ShowMyRisks();
          },
            error => {
              //console.error("Error: ", error);
              // alert('Error:!' + error.message + '\nProblem getting User info!\n');
            });
  }

  public getMessageFromChild(message: string) {
    if (message === 'refresh') {
      // ToDo - add code to save which mode the page is in and use it here when refreshing the page.
      this.ShowMyRisks();
    }
  }

  public ShowMyRisks() {
    // Get my risk  data and show it
    this.getMyRiskData();
    this.showApprovals = false;
  }

  public ShowManagerRisks() {
    // Get manager risk  data and show it
    this.getManagerRiskData(); // to do - update this call for manager data
    this.showApprovals = false;
  }

  public ShowAllRisks() {
    // Get manager risk  data and show it
    this.getAllRiskData(); // to do - review and test this call for all data
    this.showApprovals = false;
  }

  public ShowAppovals() {
    // Get the Approvals data and show all RiskEvents that need approval

    this.showApprovals = true;
    this.getAllApprovals();

  }

  public getMyRiskData() {
    this.riskData$ = this.getMyRisks();
    this.mitigatingActions$ = this.getMyMitigations();
    this.overdueMitigatingActions$ = this.getMyOverdueMitigations();
    this.riskEvents$ = this.getMyRiskEvents();
    this.alertRisks$ = this.getAlertRisks();
    this.overdueRisks$ = this.getOverdueRisks();
  }

  public getManagerRiskData() {
    this.riskData$ = this.getManagerRisks();
    this.mitigatingActions$ = this.getMyMitigations();
    this.overdueMitigatingActions$ = this.getMyOverdueMitigations();
    this.riskEvents$ = this.getMyRiskEvents();
    this.alertRisks$ = this.getAlertRisks();
    this.overdueRisks$ = this.getOverdueRisks();
  }

  public getAllRiskData() {
    this.riskData$ = this.getAllRisks();
    this.mitigatingActions$ = this.getAllMitigations();
    this.overdueMitigatingActions$ = this.getOverdueMitigations();
    this.riskEvents$ = this.getAllRiskEvents();
    this.alertRisks$ = this.getAlertRisks();
    this.overdueRisks$ = this.getOverdueRisks();
  }

  public isRiskOverdue = (element, index, array) => {
    let today = new Date();
    let riskDate = new Date(element.nextReviewDate);
    let overDue = (today > riskDate);
    return overDue;
  };

  public isMyMitigation = (element, index, array) => {
    return (element.controlOwnerName === this.user.firstname + ' ' + this.user.surname);
  };

  public isRiskOnAlert = (element, index, array) => {
    return (element.alertLevel > 0);
  };

  //TODO: move these into services
  public getAllApprovals(): Observable<RiskEvent[]> {
    const apiAddress: string = `RiskEvents/Approvals`;
    return this.repository.getData(apiAddress).pipe(
      shareReplay(),
      map((approvalRiskEvents: RiskEvent[]) => approvalRiskEvents)
    );
  }

  public getMyMitigations(): Observable<MitigatingAction[]> {
    return this.getAllMitigations().pipe(
      map((mitigatingActions: MitigatingAction[]) => mitigatingActions.filter(this.isMyMitigation))
    );
  }

  public getAllMitigations(): Observable<MitigatingAction[]> {
    const apiAddress: string = `MitigatingActions`;
    return this.repository.getData(apiAddress).pipe(
      shareReplay(),
      map((mitigatingActions: MitigatingAction[]) => mitigatingActions)
    );
  }

  public getMyOverdueMitigations(): Observable<MitigatingAction[]> {
    return this.getOverdueMitigations().pipe(
      map((overdueMitigatingActions: MitigatingAction[]) => overdueMitigatingActions.filter(this.isMyMitigation))
    );
  }

  public getOverdueMitigations(): Observable<MitigatingAction[]> {
    const apiAddress: string = `MitigatingActions?status=overdue`;
    return this.repository.getData(apiAddress).pipe(
      shareReplay(),
      map((overdueMitigatingActions: MitigatingAction[]) => overdueMitigatingActions)
    );
  }

  public getAllRiskEvents(): Observable<RiskEvent[]> {
    const apiAddress: string = `RiskEvents`;
    return this.repository.getData(apiAddress).pipe(
      shareReplay(),
      map((riskEvents: RiskEvent[]) => riskEvents)
    );
  }

  public getMyRiskEvents(): Observable<RiskEvent[]> {
    // ToDo - check owner of risk event - i.le. creator create an api call for my RiskEvents - then update this block
    // and / or owner of risk
    const apiAddress: string = `RiskEvents/MyRiskEvents`;
    return this.repository.getData(apiAddress).pipe(
      shareReplay(),
      map((riskEvents: RiskEvent[]) => riskEvents)
    );
  }

  public getMyRisks(): Observable<Risk[]> {
    this.riskType = 0; //
    return this.riskService.getMyRisks().pipe(
      shareReplay(),
    );
  }

  public getManagerRisks(): Observable<Risk[]> {
    this.riskType = 0; //
    return this.riskService.getMyManagerRisks().pipe(
      shareReplay(),
    );
  }

  public getAllRisks(): Observable<Risk[]> {
    this.riskType = 0; //
    return this.riskService.getAllRisks().pipe(
      shareReplay(),
    );
  }

  public getAlertRisks(): Observable<Risk[]> {
    return this.riskData$.pipe(
      shareReplay(),
      map((data: Risk[]) => data.filter(this.isRiskOnAlert))
    );
  }

  public getOverdueRisks() {
    return this.riskData$.pipe(
      shareReplay(),
      map((data: Risk[]) => data.filter(this.isRiskOverdue))
    );
  }


  toggleOverdueRisks() {
    // Do nothing - not allowed to hide overdue Risks
  }

  toggleOverdueMitigations() {
    // Do nothing - not allowed to hide overdue Mitigations
  }

  public toggleRisks() {
    this.showRisks = !this.showRisks;
  }

  toggleAlertRisks() {
    this.showAlertRisks = !this.showAlertRisks;
  }

  public toggleMitigations() {

    this.showMitigations = !this.showMitigations;
  }

  public toggleRiskEvents() {
    this.showRiskEvents = !this.showRiskEvents;
  }
  toggleRiskEventApprovals() {

  }
}
